import type { Account } from '../account-mapping/shared-types'
import type { MentionItem } from '@app/shared/vue/components/sf-markdown-editor/types'
import type { ReconciliationTemplate, Export } from './types'
import { DocumentTypeValues } from '@app/shared/vue/components/sf-markdown-editor/constants'

export const findLiveInputFromBubble = (
  bubble: HTMLElement | null,
  path: string
): HTMLElement | null | undefined => {
  const parent = bubble?.parentNode?.parentNode as HTMLElement

  if (!parent) {
    return
  }

  return parent?.querySelector<HTMLElement>(`[data-name="${path}"]`)
}

export const anyCheckinFromOtherUsers = (checkinUserIds: number[]): boolean => {
  const currentUserId = parseInt(window.Silverfin.currentUserId())

  return (
    checkinUserIds.length > 0 &&
    checkinUserIds.some((id) => id !== currentUserId)
  )
}

export const formatMentionAccounts = (
  accounts: Account[],
  companyId: string,
  ledgerId: string
): MentionItem[] =>
  Object.values(accounts).map((account) => ({
    id: account.name || '',
    type: DocumentTypeValues.ACCOUNT_ENTRY,
    link: window.Silverfin.Routes.ledger_account_path(
      window.Silverfin.currentFirmId,
      companyId,
      ledgerId,
      account.id
    ),
  }))

export const formatMentionReconTemplates = (
  reconTexts: ReconciliationTemplate[],
  companyId: string,
  ledgerId: string
): MentionItem[] =>
  reconTexts.map((recon) => ({
    id: recon.name || '',
    type: DocumentTypeValues.RECONCILIATION_TEMPLATE,
    link: window.Silverfin.Routes.ledger_reconciliation_text_path({
      firm_id: window.Silverfin.currentFirmId,
      company_id: companyId,
      ledger_id: parseInt(ledgerId),
      id: recon.id,
      _options: true,
    }),
  }))

export const formatMentionExports = (exports: Export[]): MentionItem[] =>
  exports.map((exp) => ({
    id: exp.title,
    type: DocumentTypeValues.EXPORT,
    link: exp.url,
  }))
